import { NewEntityId } from "../../data/constants";
import {
  CourseViewModel,
  CourseStatus,
  CourseCertificateValidity,
  RequiredCourse,
  CourseType,
} from "../../model/Course";

export const initialCourse: CourseViewModel = {
  id: NewEntityId,
  nameDE: "",
  nameEN: "",
  nameFR: "",
  nameIT: "",
  numberOfMandatoryModules: 0,
  numberOfProcessModules: 0,
  numberOfSelectionModules: 0,
  modulesValidity: null,
  certificateValidity: CourseCertificateValidity.Unlimited,
  status: CourseStatus.Draft,
  modules: [],
  modulesRelevantForGrade: [],
  type: CourseType.None,
};
export const getInitialRequiredFieldsStatuses = (): RequiredCourse => ({
  isNameDEEmpty: false,
  isNameENEmpty: false,
  isNameFREmpty: false,
  isNameITEmpty: false,
  isModuleNumbersZero: false,
  isModuleListEmpty: false,
  isTypeEmpty: false,
});
